var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":_vm.description,"delay":300,"type":"is-dark","position":_vm.position}},[_c('b-icon',{attrs:{"icon":_vm.icon,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }